import React, { createContext, useContext } from "react";

export type SelectSize = "sm" | "md" | "lg";

export interface SelectContextType<T = unknown> {
  /** The currently selected item (full object), or null/undefined if nothing selected. */
  value: T | null | undefined;
  /** Called when the user picks an option. Receives the full option object. */
  onSelect: (item: T) => void;
  /** The data array powering the options list. */
  data: T[];
  /** Returns a stable key for each option (used for deduplication and selection matching). */
  getOptionKey: (item: T) => string | number;
  /** Whether the dropdown is currently open. */
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  /** Shared size applied to trigger and options list. */
  size: SelectSize;
}

export const SelectContext = createContext<SelectContextType<any> | null>(null);

export function useSelectContext<T>(): SelectContextType<T> {
  const ctx = useContext(SelectContext);
  if (!ctx) {
    throw new Error("Select sub-components must be used inside <Select>");
  }
  return ctx as SelectContextType<T>;
}
